import { render, staticRenderFns } from "./hero-slider.vue?vue&type=template&id=30a3cbce"
import script from "./hero-slider.vue?vue&type=script&lang=js"
export * from "./hero-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports